module.exports = __webpack_public_path__ + "img/reports.5e4f8f9c.svg";